// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * @internal
 */
export enum GrantType {
  authCode = "authorization_code",
  ssoToken = "sso_token",
}
